// 资源图片（道具图标）解析：图片放 static/item-icons 下，与 static/svg（UI 图标）分离
// JSON 中只存文件名（如 jinliulu.png）；渲染时统一调用 iconUrl(name) 拼成可直用地址
// 说明：assets/icons + import.meta.glob 在当前 uni-app H5 构建下只能打包部分资源，不稳定；

//       故采用 static 子目录 + 路径拼接（全端可靠、零构建依赖），同样实现资源图与 UI 图分离
const GAME_ICON_DIR = '/src/assets/game-icons'

// import.meta.glob 的第一个参数必须是纯粹的字符串字面量，严禁使用变量、字符串拼接（+）或模板字符串（ 
const gameIconList = import.meta.glob('/src/assets/game-icons/**/*.png', {
	eager: true
});


// 图标渲染规则（单一事实来源，供 ToolCard / AppBottomNav 等共用）：
//  - 以 http(s):// 开头        → 直接当图片地址
//  - 以 /static/ 开头           → 已是静态资源路径，直接当图片
//  - 以 .svg 结尾               → 引用 static/svg/ 目录下同名文件
//  - 以 .png 结尾               → 引用 static/item-icons/ 目录下同名文件（兼容 @ 前缀）  推荐使用gameIcon
//  - 其余（emoji / HTML 片段）  → 按原方式 v-html 渲染
export function resolveIcon(icon) {
	if (typeof icon !== 'string') return {
		type: 'html',
		value: ''
	}
	if (/^https?:\/\//.test(icon)) return {
		type: 'img',
		src: icon
	}
	if (icon.startsWith('/static/')) return {
		type: 'img',
		src: icon
	}

	// 游戏图标
	let get_icon = gameIcon(icon)
	if (get_icon) return {
		type: 'img',
		src: get_icon
	}

	if (icon.endsWith('.svg')) {
		const name = icon.includes('/') ? icon.split('/').pop() : icon
		return {
			type: 'img',
			src: '/static/svg/' + name
		}
	}
	if (icon.endsWith('.png')) {
		const name = icon.includes('/') ? icon.split('/').pop() : icon
		return {
			type: 'img',
			src: '/static/icon/' + name
		}
	}
	return {
		type: 'html',
		value: icon
	}
}

// 游戏图标
export function gameIcon(icon) {
	
	if(typeof icon==='object'){
		icon=icon?.icon || icon?.src
	}
	
	if(!icon){
		return '';
	}
	
	const iconName = icon.replace(/^@/, '');
	const key = GAME_ICON_DIR + `/${iconName}`;
	
	if (gameIconList[key]) {
		return gameIconList[key].default;
	}

	return '';
}